const SUPPORT_REQUEST_STATUS_VALUES = ['open', 'in_progress', 'resolved', 'closed'];
const SUPPORT_REQUEST_PRIORITY_VALUES = ['low', 'medium', 'high', 'urgent'];
const ORDER_STATUS_VALUES = ['created', 'paid', 'shipped', 'cancelled'];
const PAYMENT_STATUS_VALUES = ['pending', 'processing', 'requires_action', 'succeeded', 'failed', 'cancelled'];
export const SUPPORT_REQUEST_STATUSES = SUPPORT_REQUEST_STATUS_VALUES;
export const SUPPORT_REQUEST_PRIORITIES = SUPPORT_REQUEST_PRIORITY_VALUES;
export const ORDER_STATUSES = ORDER_STATUS_VALUES;
export const PAYMENT_STATUSES = PAYMENT_STATUS_VALUES;
const SUPPORT_STATUS_SET = new Set(SUPPORT_REQUEST_STATUSES);
const SUPPORT_PRIORITY_SET = new Set(SUPPORT_REQUEST_PRIORITIES);
const ORDER_STATUS_SET = new Set(ORDER_STATUSES);
const PAYMENT_STATUS_SET = new Set(PAYMENT_STATUSES);
const normalizeString = (value) => {
    if (typeof value !== 'string')
        return null;
    const normalized = value.trim().toLowerCase();
    return normalized ? normalized : null;
};
const normalizeStatus = (value, validSet) => {
    const normalized = normalizeString(value);
    if (!normalized)
        return null;
    if (validSet.has(normalized))
        return normalized;
    return null;
};
export const normalizeSupportRequestStatus = (value) => normalizeStatus(value, SUPPORT_STATUS_SET);
export const normalizeSupportRequestPriority = (value) => normalizeStatus(value, SUPPORT_PRIORITY_SET);
export const normalizeOrderStatus = (value) => normalizeStatus(value, ORDER_STATUS_SET);
export const normalizePaymentStatus = (value) => normalizeStatus(value, PAYMENT_STATUS_SET);
export const isSupportRequestStatus = (value) => normalizeSupportRequestStatus(value) !== null;
export const isSupportRequestPriority = (value) => normalizeSupportRequestPriority(value) !== null;
export const isOrderStatus = (value) => normalizeOrderStatus(value) !== null;
export const isPaymentStatus = (value) => normalizePaymentStatus(value) !== null;
